import $request from './request'
import { base, dataUrl } from './config'

// 登录
export function login(data) {
  return $request.post(base + '/srm-auth/auth/loginSrm', data)
}

// 账号列表
export function getAccountList(data) {
  return $request.post(base + '/srm-public/user/queryUserPageByTenant', data)
}

// 获取当前企业已建启用的账号
export function getEnableAccountNum(data) {
  return $request.get(base + '/srm-public/user/getEnableAccountNum', data)
}

// 获取账号信息
export function getUserInfo(data) {
  return $request.post(base + '/srm-public/user/queryorgbyuserid/' + data)
}

// 修改密码
export function modifypassword(data) {
  return $request.post(base + '/srm-public/user/modifypassword', data)
}

// 获取验证码
export function sendsmscode(data) {
  return $request.post(base + '/srm-public/user/sendSmsCodeOfSrm', data)
}

// 校验验证码
export function validatesmscode(data) {
  return $request.post(base + '/srm-public/user/validatesmscode', data)
}

// 找回密码
export function findpassword(data) {
  return $request.post(base + '/srm-public/user/findpassword', data)
}

// 禁用账号
export function disableAccount(data, enable) {
  return $request.post(base + `/srm-public/user/disable/${data}`)
}

// 启用账号
export function enableAccount(data) {
  return $request.post(base + `/srm-public/user/enable/${data}`)
}

// 创建/编辑账号
export function modifyAccount(data) {
  return $request.post(base + `/srm-public/user/accountEdit`, data)
}

// 获取账号详情
export function getAccountInfo(data) {
  return $request.post(base + `/srm-public/user/findbyid/${data}`)
}

// 获取登录用户的按钮级权限
export function queryButtonResourceList() {
  return $request.post(base + `/srm-auth/user/queryButtonResourceListTenant`)
}

// 角色列表
export function getRoleList(data) {
  return $request.post(base + `/srm-public/role/list`, data)
}

// 根据角色id将合并的资源id返回
export function queryResourceListByRoles(data) {
  return $request.post(base + `/srm-public/role/queryResourceListByRoles`, data)
}

// 获取权限树
export function getResourceList(data) {
  return $request.post(base + `/srm-public/role/treeOfSrm/0`, data)
}

// 新增角色
export function createRole(data) {
  return $request.post(base + `/srm-public/role/create`, data)
}

// 编辑角色
export function editRole(data) {
  return $request.post(base + `/srm-public/role/edit`, data)
}

// 获取角色权限树
export function getRoleResource(data) {
  return $request.post(base + `/srm-public/role/treeOfSrm/${data}`)
}

// 获取角色详情
export function getRoleInfo(data) {
  return $request.post(base + `/srm-public/role/queryRoleInfo`, data)
}

// 禁用启用角色
export function enableOrDisableRole(data) {
  return $request.post(base + `/srm-public/role/disableOrEnable/${data}`)
}

// 获取枚举值
export function getType(data) {
  return $request.get(dataUrl + `/common/getType/${data}`)
}

// 获取单位
export function getUnitList() {
  return $request.post(dataUrl + `/standardLibrary/queryUnitList`)
}

// 根据类型获取单位
export function getUnitListByType(data) {
  return $request.get(dataUrl + `/standardLibrary/getUnitList/${data.type}`)
}

// 获取日志
export function queryLogInfo(data) {
  return $request.post(dataUrl + `/log/queryLogInfo`, data)
}

// 导出配置左边列表
export function downLeftOper(data) {
  return $request.post(
    dataUrl + `/export/queryExportTemplateConfigByParam`,
    data
  )
}

// 导出配置右边列表
export function downRightOper(data) {
  return $request.post(dataUrl + `/export/queryExportTemplateByBizType`, data)
}

// 保存导出配置
export function saveDownOper(data) {
  return $request.post(dataUrl + `/export/saveExportTemplate`, data)
}

// 同步保存
export function asyncExport(data) {
  return $request.post(dataUrl + `/export/asyncExport`, data)
}

// 获取企业名称
export function getCompanyName(data) {
  return $request.post(dataUrl + `/companyInformation/getCompanyName`, data)
}

// 成品主档查询企业信息名称
export function getTenantInName(data) {
  return $request.post(dataUrl + `/traceabilityInfo/getTenantInfo`, data)
}

// 编辑企业信息
export function companyEdit(data) {
  return $request.post(dataUrl + `/companyInformation/edit`, data)
}

// 获取企业信息
export function getCompanyInfo(data) {
  return $request.post(dataUrl + `/companyInformation/queryInfo`, data)
}

// 获取下载中心列表
export function queryExportTask(data) {
  return $request.post(dataUrl + `/export/queryExportTask`, data)
}

// 获取系统日志列表
export function queryLogList(data) {
  return $request.post(dataUrl + `/log/page`, data)
}

// 添加浏览日志
export function saveBrowseLog(data) {
  return $request.post(dataUrl + `/log/saveBrowse`, data)
}

// 获取字典表枚举
export function getDictList(data) {
  return $request.get(dataUrl + `/common/getDictList/${data.code}`, data)
}

// 获取用户表头数据
export function getUserConfig(data) {
  return $request.post(dataUrl + `/table/getUserConfig`, data)
}

// 保存用户表头数据
export function saveUserConfig(data) {
  return $request.post(dataUrl + `/table/saveUserConfig`, data)
}

// 获取地址信息
export function getChildAddress(data) {
  return $request.post(dataUrl + `/common/getChildAddress`, data)
}

// 查询所有父级地址
export function getParentAddress(data) {
  return $request.post(dataUrl + `/common/getParentAddress`, data)
}
